import { operateMaxShowLength } from '@/store/dict/config'


export const STATE_ENUM = {
  DISABLE: 0,
  ENABLE: 1,
}

export const MODE_ENUM = {
  STATIC: 1, // 详情
  EDIT: 2, // 编辑
  ADD: 3, // 新增
  COPY: 4, // 新增
}

// 资源类型（1目录 2页面 3按钮）
export const TYPE_ENUM = {
  DICT: 1, // 详情
  PAGE: 2, // 编辑
  BTN: 3, // 新增
}

export const config = function () {
  const headData = [
    {
      name: 'id',
      columnProps: {
        prop: 'id',
        label: '角色ID',
      },
    },
    {
      name: 'name',
      columnProps: {
        prop: 'name',
        label: '角色名称',
        width: 200,
      },
      render: ({ row }) => {
        if (row.type === 0) return row.name
        return (
          <div>
            <span style="color: #366CFE; background-color: #E8F2FF; padding: 3px 5px; border-radius: 2px;">系统</span>
            {row.name}
          </div>
        )
      },
    },
    {
      name: 'userCount',
      columnProps: {
        prop: 'userCount',
        label: '员工数量',
      },
    },
    {
      name: 'gmtCreate',
      columnProps: {
        prop: 'gmtCreate',
        label: '创建时间',
        width: 160,
      },
    },
    {
      name: 'createUser',
      columnProps: {
        prop: 'createUser',
        label: '创建人',
      },
    },
    {
      name: 'gmtModified',
      columnProps: {
        prop: 'gmtModified',
        label: '最后更新时间',
        width: 160,
      },
    },
    {
      name: 'modifiedUser',
      columnProps: {
        prop: 'modifiedUser',
        label: '最后更新人',
      },
    },
  ]
  const operateColumn = {
    name: 'operate',
    columnProps: {
      label: '操作',
      width: 240,
      fixed: 'right',
    },
    maxShowLength: operateMaxShowLength,
    type: 'operate',
    getOperateList: ({ row }) => {
      const btns = []
      const edit = {
        name: 'edit',
        label: '编辑',
        action: () => {
          this.edit(row)
        },
      }
      const copy = {
        name: 'copy',
        label: '复制',
        action: () => {
          this.copy(row)
        },
      }
      const info = {
        name: 'info',
        label: '查看',
        action: () => {
          this.info(row)
        },
      }
      const deleteRole = {
        name: 'deleteRole',
        label: '删除',
        action: () => {
          this.deleteRole(row)
        },
      }
      if (this.judgePermission('tenant_new_role_list_info')) {
        btns.push(info)
      }
      // 权限 tenant_new_role_list_copy'
      if (this.judgePermission('tenant_new_role_list_copy')) {
        btns.push(copy)
      }
      if (row.type === 0) {
        // tenant_new_role_list_delete 权限
        this.judgePermission('tenant_new_role_list_edit') && btns.push(edit)
        this.judgePermission('tenant_new_role_list_delete') && btns.push(deleteRole)
      }
      return btns
    },
  }
  return { headData, operateColumn }
}
